import * as React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import axios from 'axios';

export default function BiaxialLineChart() {
  const [range, setRange] = React.useState('This Week');
  const [salesData, setSalesData] = React.useState(null); // Store fetched data
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);


  const restaurantId = sessionStorage?.getItem("store_id") || "Null";
  // Fetch once on mount
  React.useEffect(() => {
    const fetchSalesData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await axios.get(`/server/dashboard-functions/salesoverview/${restaurantId}`);
        setSalesData(response.data.data); 
      } catch (err) {
        setError('Failed to fetch sales data');
      } finally {
        setLoading(false);
      }
    };

    fetchSalesData();
  }, []); 
const Loader = () => (
    <div className="flex justify-center items-center h-full min-h-[300px]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-[#E57320]  border-solid"></div>
    </div>
);
 
  if (loading) return <Loader />;
  if (error) return <p>{error}</p>;
  if (!salesData) return <p>No data available</p>;

  const chartData = salesData[range];

  return (
    <>
    
      <div className="flex justify-between items-center mb-4">
        <p className="text-2xl text-gray-800">Sales Overview</p>
       <div className="relative inline-block">
<select
  value={range}
  onChange={(e) => setRange(e.target.value)}
  className="appearance-none border border-gray-300 px-4 py-2 rounded-lg text-gray-800 bg-white 
  shadow-sm hover:shadow-md focus:ring-2 focus:ring-[#EF7320] focus:border-[#EF7320] 
  cursor-pointer transition-all duration-200 outline-none pr-8 w-[180px]"
>
  <option value="This Week" className="text-gray-800 hover:text-[#EF7320]">
    This Week
  </option>
  <option value="Last Week" className="text-gray-800 hover:text-[#EF7320]">
    Last Week
  </option>
  <option value="Last 30 Days" className="text-gray-800 hover:text-[#EF7320]">
    Last 30 Days
  </option>
  <option value="This Month" className="text-gray-800 hover:text-[#EF7320]">
    This Month
  </option>
</select>


  {/* Custom dropdown arrow */}
  <svg
    className="w-4 h-4 absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
</div>

      </div>

      <LineChart
        height={300}
        series={[
          {
            data: chartData.sales,
            label: 'Sales',
            yAxisId: 'leftAxisId',
            color: '#CA585C',
          },
        ]}
        xAxis={[{ scaleType: 'point', data: chartData.dates }]}
        yAxis={[{ id: 'leftAxisId', width: 100 }]}
      />
      
      
    </>
  );
}
